import { jsxs as r, jsx as t } from "react/jsx-runtime";
import { tv as o } from "tailwind-variants";
const a = o({
  base: [
    "font-bold",
    "font-secondary",
    "sr-only",
    "text-sm",
    "uppercase",
    "w-full"
  ],
  variants: {
    isLabelVisible: {
      true: ["not-sr-only"]
    }
  }
}), i = ({ isLabelVisible: l, progress: s }) => {
  const e = Math.round(s * 100);
  return /* @__PURE__ */ r("div", { className: "flex flex-col gap-2 w-full", children: [
    /* @__PURE__ */ t(
      "div",
      {
        className: "h-[0.75rem] rounded-full w-full bg-[linear-gradient(to_right,theme(colors.blue.500)_var(--percent),theme(colors.neutral.200)_var(--percent))]",
        style: {
          "--percent": `${e}%`
        }
      }
    ),
    /* @__PURE__ */ r("span", { className: a({ isLabelVisible: l }), children: [
      e,
      "% completed"
    ] })
  ] });
};
export {
  i as default
};
